import { useEffect, useState } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { loadConfig } from "./authConfig";
import Landing from "./Landing";

const config = loadConfig();
const pca = new PublicClientApplication(config.msalConfig);

export default function App() {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await pca.initialize();

        const response = await pca.handleRedirectPromise();
        if (response && response.account) {
          pca.setActiveAccount(response.account);
        }

        if (pca.getAllAccounts().length > 0) {
          window.location.replace(config.redirectUrl);
        }
      } catch (err) {
        console.error("MSAL check failed", err);
      }

      if (!cancelled) setChecking(false);
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleLogin = () => {
    pca.loginRedirect(config.loginRequest).catch((err) => {
      console.error("loginRedirect failed", err);
    });
  };

  if (checking) {
    return (
      <div id="rg-loading">
        <div className="rg-spinner" />
      </div>
    );
  }

  return <Landing onLogin={handleLogin} />;
}
